<template>
  <div>
    
    <!-- <h2>Search and add a pin</h2> -->
   
    <gmap-map
      :center="center"
      :zoom="12"
      style="width:100%;  height: 500px;"
    >
      <gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        :clickable="true"
        @click="center=m.position"
      ></gmap-marker>
    </gmap-map>


  </div>
</template>

<script>
export default {
    // name: "GoogleMap",

    mounted(){

      console.log(`Location: ${JSON.stringify(this.location)}`)
    },

    props: {

        location: {

            type: Object,
            default: () => ({}) 
        },
    },

    data() {
        return {
        // default to Montreal to keep it simple
        // change this to whatever makes sense
        center: { lat: 29.3759, lng: 47.9774 },
        markers: [],
        };
    },

    mounted() {
            
      // console.log(`location is ${JSON.stringify(this.location)}`);

      this.addMarker();

      // console.log(`location is ${JSON.stringify(location)}`);

    },

    methods: {
        // receives a place object via the autocomplete component
        setPlace(place) {
        this.currentPlace = place;
        },
        addMarker() {
            

          while(this.markers.length > 0){

              this.markers.pop();
          }
            
          if(JSON.stringify(this.location) ==='{}'){

            //console.log(`return`);

            return;
          }

         // console.log(`location is ${Object.keys(this.location).length}`);

          if(Object.keys(this.location).length > 0);
          {
            const marker = {
                
                lat: Number(this.location.latitude),
                lng: Number(this.location.longitude)
            };

            this.markers.push({ position: marker });

            // console.log(`this location is ${JSON.stringify(this.location)}`)

            this.center = marker;
          }
        },
    },


    watch: {
      
      location: {
        handler(val){
          
         while(this.markers.length > 0){

              this.markers.pop();
          
          }

          if(JSON.stringify(val) ==='{}'){

          //console.log(`return`);

            return;
          } 
          
         // console.log(`location is ${Object.keys(val).length}`);

            if(Object.keys(val).length > 0);
            {

              const marker = {
                  
              lat: Number(val.latitude),
              lng: Number(val.longitude)
              };
              

              this.markers.push({ position: marker });

              // console.log(`this location is ${JSON.stringify(this.location)}`)

              this.center = marker;  
            }
                
          },

        deep: true
      }
    }
};
</script>